import type { FC } from "react";

import { cn } from "@/ui/lib/utils";
import { TLabelProps } from "@/ui/components/form/Label";
import { TextControl } from "../../typography/TextControl";

export const Label: FC<TLabelProps> = (
  {
    className,
    children,
    ...props
  },
) => {

  return (
    <TextControl
      {...props}
      tag="span"
      size={2}
      data-component="Label"
      className={cn(
        className,
      )}
      isResponsive={false}
    >
      { children }
    </TextControl>
  );
};

Label.displayName = "Label";
